import { makeApiCall } from "./makeApiCall";
import { Url } from "./constantUrl";
import {
    FETCH_REFERRAL_LIST_REQUEST,
    FETCH_REFERRAL_LIST_SUCCESS,
    FETCH_REFERRAL_LIST_FAILURE
} from './types';

// Action to fetch Referral data
export const fetchReferralList = (page = 1, pageSize = 10, filters = {}) => async (dispatch) => {
    const endpoint = Url.GET_REFERRAL_LIST

    return makeApiCall({
        method: 'GET',
        endpoint,
        dispatch,
        requestType: FETCH_REFERRAL_LIST_REQUEST,
        successType: FETCH_REFERRAL_LIST_SUCCESS,
        failureType: FETCH_REFERRAL_LIST_FAILURE,
        params: {
            page,
            page_size: pageSize,
            ...filters
        },
    });
};